// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__2rtJm","label":"Labeled_label__35QF6","divider":"Labeled_divider__2iZhT"};